<template>
  <div class="py-5 md:px-5">
    <PageHeader class="container" title="Contacts">
      <router-link :to="{ name: 'ContactCreate' }" class="btn btn-primary">
        Add Contact
      </router-link>
    </PageHeader>

    <div class="container">
      <!-- Loading -->
      <Loading v-if="loading" class="p-6" />
      <!-- List -->
      <div class="card" v-else>
        <!-- No Results -->
        <div v-if="contacts.meta.total < 1" class="max-w-sm py-12 mx-auto text-center">
          <div class="mb-2 text-lg font-bold">
            You don't have any contacts yet.
          </div>
          <div class="text-gray-500">
            Contacts can be added on automations, and receive scheduled digests.
          </div>
          <router-link :to="{ name: 'ContactCreate' }" class="mt-4 btn btn-outline">
            Add Contact
          </router-link>
        </div>

        <!-- Table -->
        <div v-else class="flex flex-col overflow-hidden">
          <div class="py-2 -my-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
            <div class="inline-block min-w-full overflow-hidden align-middle rounded-t-lg">
              <table class="min-w-full">
                <thead>
                  <tr>
                    <th class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b bg-gray-50">
                      Name
                    </th>
                    <th class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b bg-gray-50">
                      Email
                    </th>
                    <th class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b bg-gray-50">
                      Cellphone
                    </th>
                    <th class="px-6 py-3 border-b bg-gray-50"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="contact in contacts.data" :key="contact.id" class="hover:bg-gray-50">
                    <td class="px-6 py-4 font-bold border-b border-gray-100 whitespace-nowrap">
                      {{ contact.name }}
                    </td>
                    <td class="px-6 py-4 border-b border-gray-100 whitespace-nowrap">
                      {{ contact.email || '-' }}
                    </td>
                    <td class="px-6 py-4 border-b border-gray-100 whitespace-nowrap">
                      {{ contact.cellphone || '-' }}
                    </td>
                    <td class="px-6 py-4 text-right border-b border-gray-100 whitespace-nowrap">
                      <router-link :to="{ name: 'ContactEdit', params: { id: contact.id } }" class="btn btn-sm btn-secondary">
                        Edit
                      </router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- Pagination -->
        <Pagination class="rounded-b-lg" :total="contacts.meta.total" :per-page="contacts.meta.per_page" :current-page="contacts.meta.current_page" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContactList',

  metaInfo: {
    title: 'Contacts'
  },

  created () {
    this.getContacts()
  },

  data () {
    return {
      loading: true,
      contacts: {}
    }
  },

  methods: {
    async getContacts () {
      try {
        const { data } = await this.$api.get(`account/${this.$route.params.account}/contacts`, {
          params: {
            page: this.$route.query.page || 1
          }
        })
        this.contacts = data.contacts
        this.loading = false
      } catch (error) {
        console.error(error)
      }
    }
  },

  watch: {
    '$route.query': {
      handler (newVal, oldVal) {
        this.getContacts()
      },
      deep: true
    }
  }
}
</script>